import React from 'react';
import { ButtonContainer, Container, Text, Title } from './styles';
import { useHistory } from 'react-router-dom';

const AstecBloqueada = ({ tema, imovel }) => {
  const history = useHistory();

  function redirectToFinanceiro() {
    history.push({
      pathname: '/financeiro',
      state: {
        idVenda: imovel.idVenda,
      },
    });
  }

  return (
    <Container>
      <Title color={tema.primaryColor}>Você tem débitos pendentes</Title>
      <Text>
        Para abrir esta solicitação, é necessário regularizar as parcelas
        vencidas.
      </Text>
      <Text>
        Clique abaixo e verifique seus débitos ou entre em contato com nossa
        central e negocie.
      </Text>
      <ButtonContainer color={tema.primaryColor}>
        <button onClick={redirectToFinanceiro}>
          <span>ver meus débitos</span>
        </button>
      </ButtonContainer>
      <Text fontSize={'12'}>
        Caso já tenha efetuado o pagamento esta solicitação será liberada em até
        48 horas.
      </Text>
    </Container>
  );
};

export default AstecBloqueada;
